import { axiosInstance } from './axiosInstance';
import type { PoolSafetyAlertChannelsResponse } from '../utils/safetyAlertLogDisplay';
import type { SafetyAlertChannelOverrides } from '../constants/poolSafetyAlertChannels';

export async function fetchPoolSafetyAlertChannels(
  poolId: number
): Promise<PoolSafetyAlertChannelsResponse> {
  const res = await axiosInstance.get<PoolSafetyAlertChannelsResponse>(
    `/api/pools/${poolId}/safety-alert-channels`
  );
  return res.data;
}

/** 시설 정보(override) + 시스템 기본이 합쳐진 유효 on/off — PoolForm 스위치와 동일 */
export function poolEffectiveSafetyChannels(
  ch: PoolSafetyAlertChannelsResponse
): SafetyAlertChannelOverrides {
  return {
    sms: Boolean(ch.sms),
    kakao: Boolean(ch.kakao),
    wearable: Boolean(ch.wearable),
  };
}
